import React from "react";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import { BiAddToQueue } from "react-icons/bi";
import { Dropdown, Menu } from "antd";

interface UIModulePagesProps {
  handleEdit: (record: any) => void;
  handleAdd: (record: any) => void;
  handleDelete: (record: any) => void;
  setIsHovered: (isHovered: boolean) => void;
  key: React.Key;
  expandedRowKey: React.Key | null;
  record: {
    name: string;
    [key: string]: any;
  };
}

const UIModulePages: React.FC<UIModulePagesProps> = (props) => {
  const { handleEdit, handleAdd, handleDelete, setIsHovered, record } = props;

  const menu = (
    <Menu>
      <Menu.Item key="add" onClick={() => handleAdd(record)}>
        <BiAddToQueue style={{ marginRight: "6px", color: "#38a169" }} />
        Add
      </Menu.Item>
      <Menu.Item key="edit" onClick={() => handleEdit(record)}>
        <AiOutlineEdit style={{ marginRight: "6px", color: "#3182ce" }} />
        Edit
      </Menu.Item>
      <Menu.Item key="delete" onClick={() => handleDelete(record)}>
        <AiOutlineDelete style={{ marginRight: "6px", color: "#e53e3e" }} />
        Delete
      </Menu.Item>
    </Menu>
  );

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Dropdown
        overlay={menu}
        trigger={["hover"]}
        overlayClassName="access-rights-cell-menu"
        mouseEnterDelay={0.2}
      >
        <div className="access-rights-pages-cell">
          <span className="access-rights-cell-dot" />
          {record?.name}
        </div>
      </Dropdown>
    </div>
  );
};

export default UIModulePages;
